// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-root svg.star-rating {
  enable-background: new 0 0 512 96;
}
app-root svg.star-rating .st0 {
  fill: #00b67a;
}
app-root svg.star-rating .st1 {
  fill: #dcdce6;
}
app-root svg.star-rating .st2 {
  fill: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Brand/ProcessOverview/LeadFeed/TrustPilot/Icons.less"],"names":[],"mappings":"AAAA;EAEI,iCAAA;AAAJ;AAFA;EAKM,aAAA;AAAN;AALA;EAQM,aAAA;AAAN;AARA;EAWM,aAAA;AAAN","sourcesContent":["app-root {\n  svg.star-rating {\n    enable-background: new 0 0 512 96;\n\n    .st0 {\n      fill: #00b67a;\n    }\n    .st1 {\n      fill: #dcdce6;\n    }\n    .st2 {\n      fill: #ffffff;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
